import { render } from "./ProcessSection.vue?vue&type=template&id=f81ffa1c&scoped=true"
const script = {}

import "./ProcessSection.vue?vue&type=style&index=0&id=f81ffa1c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\knhmb\\Documents\\Khalid\\Job\\MarvelConnect Technology\\Projects\\One Shop Online Shopping\\one-shop-online-shopping\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f81ffa1c"]])

export default __exports__